<iframe [src]="idmUrl" style="width:100%; height:100%; border:0; overflow:hidden;"></iframe>
